export const space = 16;
export const titleFontSize = 24;



// WEBPACK FOOTER //
// ./src/constants/styles.js